/**
 * Created by F1231657 on 2018/1/4.
 */
// 1.引入vue和vue-router并赋值给相应的Vue和Router
import Vue from 'vue';
import Router from 'vue-router';

import home from '@/components/home'; //首页
import homePage from '@/components/home/homePage'; //首页
import conceptIncubation from '@/components/home/conceptIncubation'; //概念孵化
import talentService from '@/components/home/talentService'; //人才服务
import eventExhibition from '@/components/home/eventExhibition'; //赛事展会
import designCrowdsourcing from '@/components/home/designCrowdsourcing'; //设计众包
import enterpriseResources from '@/components/home/enterpriseResources'; //企业资源
import designResources from '@/components/home/designResources'; //设计资源
import newsAndInformation from '@/components/home/newsAndInformation'; //新闻资讯
import policiesAndRegulations from '@/components/home/policiesAndRegulations'; //政策法规

import newsList from '@/components/home/common/news'; //公共的新闻列表页面
import dsignCg from '@/components/home/common/dsignCg'; //设计成果
import disgnZhuanjia from '@/components/home/common/disgnZhuanjia'; //设计专家资源
import disgnJigou from '@/components/home/common/disgnJigou'; //设计机构
//import disgnJigou from '@/components/home/common/disgnJigou'; //设计师

import twoLevelPage from '@/components/twoLevelPage/index'; //详情3页面
import works_more from '@/components/home/works/works_more'; //geng多案例
import works_user from '@/components/home/works/works_user'; //geng多案例

import oUserAdmin_index from '@/components/oUserAdmin/index'; //设计师后台管理

//手机端路由
import mobIndex from '@/components/mobile/index'; //手机首页
import mHomepage from '@/components/mobile/classfy/homePage'; //首页
import mnewInfo from '@/components/mobile/two/index'; //新闻详情muser_works
import mnewList from '@/components/mobile/two/newsList'; //新闻列表
import muser_works from '@/components/mobile/two/user_works'; //人的作品
import muser_works_jigou from '@/components/mobile/two/user_works_jigou'; //jigou的作品
import mworks_more from '@/components/mobile/classfy/works_more'; //jigou的作品
import m_designCg from '@/components/mobile/two/m_designCg'; //jigou的作品

Vue.use(Router)
const router = new Router({
	linkActiveClass: 'active', // 指定路由选中时的样式类名
	hashbang: true, // 将路径格式化为#!开头
	history: true, // 启用HTML5 history模式，可以使用pushState和replaceState来管理记录
	routes: [{
		path: '/',
		name: "home",
		component: home,
		children: [{
			path: '/homePage',
			name: "homePage",
			components: {
				homeRoter: homePage
			}
		}, {
			path: '/conceptIncubation',
			name: "conceptIncubation",
			components: {
				homeRoter: conceptIncubation
			}
		}, {
			path: '/talentService',
			name: "talentService",
			components: {
				homeRoter: talentService
			}
		}, {
			path: '/eventExhibition',
			name: "eventExhibition",
			components: {
				homeRoter: eventExhibition
			}
		}, {
			path: '/designCrowdsourcing',
			name: "designCrowdsourcing",
			components: {
				homeRoter: designCrowdsourcing
			}
		}, {
			path: '/enterpriseResources',
			name: "enterpriseResources",
			components: {
				homeRoter: enterpriseResources
			}
		}, {
			path: '/designResources',
			name: "designResources",
			components: {
				homeRoter: designResources
			}
		}, {
			path: '/newsAndInformation',
			name: "newsAndInformation",
			components: {
				homeRoter: newsAndInformation
			}
		}, {
			path: '/policiesAndRegulations',
			name: "policiesAndRegulations",
			components: {
				homeRoter: policiesAndRegulations
			}
		}, {
			path: 'twoLevelPage',
			name: "twoLevelPage",
			components: {
				homeRoter: twoLevelPage
			}
		}, {
			path: 'newsList',
			name: "newsList",
			components: {
				homeRoter: newsList
			}
		}, {
			path: 'dsignCg',
			name: "dsignCg",
			components: {
				homeRoter: dsignCg
			}
		}, {
			path: 'disgnZhuanjia',
			name: "disgnZhuanjia",
			components: {
				homeRoter: disgnZhuanjia
			}
		}, {
			path: 'disgnJigou',
			name: "disgnJigou",
			components: {
				homeRoter: disgnJigou
			}
		}]
	}, {
		path: '/oUserAdmin_index',
		name: "oUserAdmin_index",
		component: oUserAdmin_index
	}, {
		path: '/works_more',
		name: "works_more",
		component: works_more
	}, {
		path: '/works_user',
		name: "works_user",
		component: works_user
	}, {
		path: '/mob',
		name: "mob",
		component: mobIndex,
		children:[{
			path: '/mHomepage',
			name: "mHomepage",
			components: {
				mobRoter: mHomepage
			}
		},{
			path: '/mnewInfo',
			name: "mnewInfo",
			components: {
				mobRoter: mnewInfo
			}
		},{
			path: '/mnewList',
			name: "mnewList",
			components: {
				mobRoter: mnewList
			}
		},{
			path: '/muser_works',
			name: "muser_works",
			components: {
				mobRoter: muser_works
			}
		},{
			path: '/muser_works_jigou',
			name: "muser_works_jigou",
			components: {
				mobRoter: muser_works_jigou
			}
		},{
			path: '/mworks_more',
			name: "mworks_more",
			components: {
				mobRoter: mworks_more
			}
		},{
			path: '/m_designCg',
			name: "m_designCg",
			components: {
				mobRoter: m_designCg
			}
		}]
	}],
	scrollBehavior(to, from, saveTop) { //解决台哦准页面后滚动条没有在顶端
		if(saveTop) {
			return saveTop;
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})
export default router